import React from 'react';
import styled from 'styled-components';
import breakpointsMinWidth from '../../../styling/breakpointsMinWidth';
import { fetchQueryParams } from '../../signUp/handleSignUp';
import { generateState, urlSafeEncode } from './validateStateUtility';
import CustomButton from './components/button';

export const SocialWrapper = styled.div`
  text-align: center;
  a {
    text-decoration: none;
  }
`;

// Social handle link styles
export const SocialLink = styled.div`
  width: 100%;
  cursor: pointer;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
  text-align: center;
  margin: 0 0 12px 0;
  padding: 12px;
  @media ${breakpointsMinWidth.tabletSm} {
    margin: 0 0 16px 0;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    &:hover {
      border: 1px solid rgba(14, 19, 24, 0.7);
      transition: border 0.2s ease-in-out;
      span {
        color: rgba(14, 19, 24, 0.8);
        transition: color 0.2s ease-in-out;
      }
    }
  }
`;

// Social handle image styles
export const SocialImg = styled.img`
  width: 24px;
  float: left;
  filter: ${(props) => props.filter};
`;

export const SocialText = styled.span`
  color: rgba(14, 19, 24, 0.7);
`;

const socials = [
  {
    name: 'Google',
    text: 'Continue with Google',
    src: 'https://s3-us-west-2.amazonaws.com/media.wisedoc.net/icons/socials/google.svg',
    authLink: `https://${process.env.REACT_APP_CUSTOM_DOMAIN}/oauth2/authorize?identity_provider=Google&redirect_uri=${process.env.REACT_APP_REDIRECT_SIGNIN}&response_type=CODE&client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile`,
  },
];

// Add real university domain and redirect URL after licensing with the university.
const universitySocials = {
  ...(process.env.REACT_APP_ENVIRONMENT !== 'production'
    ? {
        'gmail.com': {
          name: 'Oregon State University',
          text: 'Login with Oregon State University',
          src: 'https://s3-us-west-2.amazonaws.com/media.wisedoc.net/icons/socials/google.svg',
          authLink: `https://${process.env.REACT_APP_DOMAIN}/oauth2/authorize?identity_provider=Google&redirect_uri=${process.env.REACT_APP_REDIRECT_SIGNIN}&response_type=CODE&client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile`,
        },
      }
    : {}),
  'nwmissouri.edu': {
    name: 'Northwest Missouri State University',
    text: 'Login with Nothwest Missouri State University',
    src: 'https://www.nwmissouri.edu/layout/v2019/images/svg/logo-n.svg',
    authLink: `https://${process.env.REACT_APP_DOMAIN}/oauth2/authorize?identity_provider=WSO2&redirect_uri=${process.env.REACT_APP_REDIRECT_SIGNIN}&response_type=CODE&client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile`,
  },
  'oregonstate.edu': {
    name: 'Oregon State University',
    text: 'Login with Oregon State University',
    src: '',
    authLink: `https://${process.env.REACT_APP_DOMAIN}/oauth2/authorize?identity_provider=osu&redirect_uri=${process.env.REACT_APP_REDIRECT_SIGNIN}&response_type=CODE&client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile`,
  },
  'wsu.edu': {
    name: 'Washington State University',
    text: 'Login with Washington State University',
    src: '',
    authLink: `https://${process.env.REACT_APP_DOMAIN}/oauth2/authorize?identity_provider=Washington&redirect_uri=${process.env.REACT_APP_REDIRECT_SIGNIN}&response_type=CODE&client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile`,
  },
  'ewu.edu': {
    name: 'Eastern Washington University',
    text: 'Login with Eastern Washington University',
    src: '',
    authLink: `https://${process.env.REACT_APP_DOMAIN}/oauth2/authorize?identity_provider=EasternWashingtonUniversity&redirect_uri=${process.env.REACT_APP_REDIRECT_SIGNIN}&response_type=CODE&client_id=${process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID}&scope=aws.cognito.signin.user.admin%20email%20openid%20phone%20profile`,
  },
};
export const handleSSOLogin = ({ universityAuth, provider, url }) => {
  const {
    location: { href },
  } = window;
  const queryParams = fetchQueryParams({ location: new URL(href) });
  const referrerIdIndex = queryParams.indexOf('referrerId');
  let referrerId = '';
  if (referrerIdIndex > -1) {
    referrerId = queryParams[referrerIdIndex + 1];
    localStorage.setItem('referrerId', referrerId);
  }
  const generatedState = generateState(32);

  const customState = encodeURIComponent(
    JSON.stringify({
      referrerId,
      isUniversityLinked: universityAuth,
    }),
  );
  const state = customState
    ? `${generatedState}-${urlSafeEncode(customState)}`
    : generatedState;

  localStorage.setItem('state', state);
  localStorage.setItem('sp', provider);
  let urlLocal = url;
  if (!universityAuth) {
    const social = socials.filter((item) => item.name === provider);
    urlLocal = social[0].authLink;
  }
  // localStorage.setItem('sso', `${urlLocal}&state=${state}`);
  window.location.replace(`${urlLocal}&state=${state}`);
};

const SSOLogin = (props) => {
  const { universityAuth } = props;
  const handleSSO = (provider) => {
    handleSSOLogin({ universityAuth, provider });
  };

  return (
    <SocialWrapper>
      {!universityAuth &&
        socials.map((social) => (
          <CustomButton
            onClick={() => handleSSO(social.name)}
            key={social.name}
            data-testid={`SSO-${social.name}`}
            startContent={
              <SocialImg
                filter={social.filter}
                src={social.src}
                alt={social.name}
              />
            }
          >
            {social.text}
          </CustomButton>
        ))}
      {universityAuth && (
        <CustomButton
          onMouseDown={() => handleSSO(universityAuth)}
          key={universityAuth}
          data-testid={`SSO-${universityAuth}`}
          startContent={
            <SocialImg
              filter={universitySocials[universityAuth].filter}
              src={universitySocials[universityAuth].src}
              alt={universitySocials[universityAuth].name}
            />
          }
        >
          {universitySocials[universityAuth].text}
        </CustomButton>
      )}
    </SocialWrapper>
  );
};

export default SSOLogin;
